export default __webpack_public_path__ + "src/images/packages/bakubung-villas/e3cc850d6afab910bd3cc98f2f81d9b4-4.jpg";